import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const Group = (props) => {
    return (_jsxs("div", { style: { border: '1px solid black', margin: '8px', padding: '8px', backgroundColor: '#f3f3f3', borderRadius: '6px' }, children: [_jsx("div", { style: { fontSize: '120%', fontWeight: 'bold', marginBottom: '1ex' }, children: props.title }), _jsx("div", { children: props.children })] }));
};
